import { Box, HStack, Header, Text, VStack, addWithConfig } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { theme } from 'styles/configure-theme';
import { primitive } from 'styles/constants/primitives';

export const AddressContainer = Box.withConfig({
  width: {
    base: 'full',
    md: '60%',
  },
  paddingY: '$2',
  paddingX: '0',
  justifyContent: 'center',
  borderStyle: 'solid',
  borderRadius: '10',
  borderBottomWidth: '1px',
  borderColor: Styles.color.white,
  backgroundColor: theme.token('background-pattern'),
  flex: 1,
  _web: {
    alignSelf: 'center',
  },
  marginTop: '3',
});

export const AddressItemsHeaderContainer = Box.withConfig({
  width: {
    base: 'full',
    md: '60%',
  },

  justifyContent: 'center',
  flex: 1,
  _web: {
    alignSelf: 'center',
  },
  marginTop: '3',
});

export const ButtonContainer = Box.withConfig({
  marginY: '$4',
  paddingX: '$4',
  width: {
    base: 'full',
    md: '50%',
  },
  _web: {
    alignSelf: 'center',
  },
  maxWidth: 'xl',
});

export const InfoContainer = Box.withConfig({
  marginLeft: '$4',
});

export const AddressInfoLine = Header.withConfig({
  variant: 'headerThree',
  margin: '0',
});

export const InfoLine = Text.withConfig({
  variant: 'copyOne',
  fontSize: '12',
  marginTop: '1',
});

export const AliasInfoLine = Box.withConfig({
  fontSize: '12',
  color: primitive.bk.$white,
  backgroundColor: primitive.bk.$bbqBrown,
  borderRadius: '3',
  paddingX: '1.5',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
  gap: '1',
});

export const AliasTextInfoLine = Text.withConfig({
  fontSize: '12',
  color: primitive.bk.$white,
});

export const DeliveryInfoContainer = Box.withConfig({
  marginY: '$3',
  marginX: 'auto',
  maxWidth: {
    base: '$64',
    md: 'full',
  },
});

export const DeliveryAddressesEditButtonContainer = HStack.withConfig({
  flex: 1,
  alignItems: 'center',
  paddingX: '$4',
});

export const DeliveryAddressesEditContainer = HStack.withConfig({
  justifyContent: 'space-between',
  alignItems: 'center',
  borderTopWidth: 1,
  borderColor: primitive.bk.$bbqBrownOpacity20,
  paddingX: '$4',
});

export const DeliveryAddressesButton = addWithConfig(ActionButton).withConfig({
  variant: ActionButtonVariants.TEXT_ONLY,
  padding: 0,
  margin: 0,
});

export const DeliveryAddressesButtonText = Text.withConfig({
  fontFamily: 'heading',
  lineHeight: '2xs',
  padding: '$2',
});

export const DeliveryAddressesName = Header.withConfig({
  fontFamily: 'heading',
  fontSize: 'sm',
  margin: 0,
  focusable: true,
  numberOfLines: 2,
});

export const DeliveryAddressesInfoContainer = VStack.withConfig({
  flex: 1,
  paddingY: '$0',
  paddingX: '$4',
});
